const roles = [
  'User',
  'Accountant',
  'Administrator',
]

const permissions = [
  [
    'jobcards.read',
    // 'Access to jobcards, clients and vehicles',
  ], // 1
  [
    'jobcards.write',
    // 'Edit and remove jobcards, clients and vehicles',
  ], // 2
  [
    'invoices.read',
    // 'Access and download invoices',
  ], // 4
  [
    'invoices.write',
    // 'Edit and remove invoices',
  ], // 8
  [
    'group.write',
    // 'Edit group settings',
  ], // 16
  [
    'export.general',
    // 'Export jobcards, clients and vehicles',
  ], // 32
  [
    'export.invoices',
    // 'Export invoices',
  ], // 64
  [
    'members.write',
    // 'Edit team members',
  ], // 128
  [
    'reports.read',
    // 'Read reports',
  ], // 256
  [
    'reports.write',
    // 'Create and remove reports',
  ], // 512
]

const permissionsMap = permissions
  .map(([key, description], index) => ({
    key,
    description,
    value: Math.pow(2, index),
  }))
  .reverse()

function intToPermissions(integer) {
  return permissionsMap
    .filter(({ value }) => {
      if (value > integer) return false

      integer -= value

      return true
    })
    .map(permission => permission.key)
}

const permissionsReversed = [ ...permissionsMap ].reverse()

export default {
  auto: '*',

  store: {
    state: {
      tokenPermissions: 1023,
    },
    getters: {
      permissions: () => permissionsReversed,

      _membership: (_, { query, _user }) =>
        query('groupsMembers', { userId: _user.id }, true),

      _permissions: ({ tokenPermissions }, { _membership }) =>
        intToPermissions(_membership ? _membership.permissions : tokenPermissions),

      // shorter alias used instead of hasGroupPermissions
      hasPermissions: (_, { _permissions }) => (...permissions) =>
        permissions.every(permission => _permissions.includes(permission)),

      groupRolesOptions: () => roles.map((role, index) => [index, role]),

      flattenByUserPermissions: (_, { _permissions }) => obj => Object
        .keys(obj)
        .filter(permission => _permissions.includes(permission))
        .flatMap(permission => obj[permission]),
    },

    mutations: {
      SET_PERMISSIONS(state, permissions) {
        state.tokenPermissions = permissions
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/groupsMembers.js